// Документ, абзац, текст и метки (полужирный, курсив, подчёркивание, индексы, код, ссылка).
import { Node } from '@tiptap/core';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Underline from '@tiptap/extension-underline';
import Code from '@tiptap/extension-code';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import Link from '@tiptap/extension-link';
import HardBreak from '@tiptap/extension-hard-break';
import { idAttr } from './util';

/** Документ: основные блоки, затем приложения (4.16: приложения - в конце). */
export const StoDocument = Document.extend({ content: 'block+ appendix*' });

export const StoParagraph = Paragraph.extend({
  addAttributes() { return { ...idAttr() }; },
});

/** Разрыв страницы (writer: {pagebreak}). */
export const PageBreak = Node.create({
  name: 'pageBreak',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,
  addAttributes() { return { ...idAttr() }; },
  parseHTML() { return [{ tag: 'div[data-type="page-break"]' }, { tag: 'hr[data-page-break]' }]; },
  renderHTML({ HTMLAttributes }) {
    return ['div', { ...HTMLAttributes, 'data-type': 'page-break', class: 'sto-pagebreak', contenteditable: 'false' },
      ['span', 'Разрыв страницы']];
  },
});

export const baseExtensions = () => [
  StoDocument,
  StoParagraph,
  Text,
  HardBreak,
  Bold, Italic, Underline, Code, Subscript, Superscript,
  Link.configure({ openOnClick: false, autolink: true, linkOnPaste: true, defaultProtocol: 'https',
    HTMLAttributes: { rel: 'noopener noreferrer', target: null } }),
  PageBreak,
];
